import { DirectiveFunction } from 'vue'
import { convertToWidthCharacter } from '@/utils'

// 荷受No(arrival_no)等の数値入力欄を全画面で統一制御するためのディレクティブ。
//   - 英字・記号などのテキスト → 入力されても除去（入力できない）
//   - 半角数字 → そのまま通す
//   - 全角数字 → 半角へ自動変換してから通す

const HYPHEN_LIKE = /[－‐‑–—−ーｰ]/g

const sanitize = (raw: string): string => {
  const half = convertToWidthCharacter(raw.replace(HYPHEN_LIKE, '-'), 'half')
  return half.replace(/[^0-9-]/g, '')
}

const numericInput: DirectiveFunction = (el: HTMLElement) => {
  const input = el.querySelector('input') as HTMLInputElement | null
  if (!input) return

  // IME変換中は保留し、確定時に処理する。
  let composing = false

  const apply = () => {
    const cleaned = sanitize(input.value)
    if (cleaned !== input.value) {
      input.value = cleaned
      input.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  input.addEventListener('compositionstart', () => {
    composing = true
  })
  input.addEventListener('compositionend', () => {
    composing = false
    apply()
  })
  input.addEventListener('input', () => {
    if (!composing) apply()
  })
}

export default numericInput
